module.exports = __webpack_public_path__ + "img/2-1.a40bb397.png";